import React from 'react';
import { useTranslation } from 'react-i18next';
import { BreadcrumbsItem, BreadcrumbsLink, BreadcrumbsList } from './styled';

export interface BreadcrumbI {
  stat: string;
  link: string;
  text: string;
}

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbI[];
  cypress: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  breadcrumbs,
  cypress
}) => {
  const { t } = useTranslation();

  return (
    <BreadcrumbsList data-cy={cypress}>
      {breadcrumbs.map(({ stat, link, text }) => (
        <BreadcrumbsItem key={link + text}>
          <BreadcrumbsLink href={link} data-stat={stat} data-cy={stat}>
            {t(text)}
          </BreadcrumbsLink>
        </BreadcrumbsItem>
      ))}
    </BreadcrumbsList>
  );
};
